import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-627cf9b8")

_pushScopeId("data-v-627cf9b8")
const _hoisted_1 = { class: "copylink" }
const _hoisted_2 = { class: "copyTxt" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "可复制【复检差异】链接", -1)
const _hoisted_4 = { class: "contentMain" }
const _hoisted_5 = { class: "contentTitle" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("li", null, "检测项", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 初检结果 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("复检结果")
const _hoisted_10 = { class: "itemTitle" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("项差异")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "itemCont" }
const _hoisted_15 = { class: "itemcol" }
const _hoisted_16 = { class: "photoViewBox" }
const _hoisted_17 = { class: "backList" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_19 = { class: "photoViewCont" }
const _hoisted_20 = { class: "swiper" }
const _hoisted_21 = { class: "swiper-wrapper" }
const _hoisted_22 = { class: "swiperSlideCont" }
const _hoisted_23 = { class: "swiper-zoom-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", {
    class: ["contain", {'PC': _ctx.state.isPc, 'H5': !_ctx.state.isPc}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_van_icon, { name: "warning" }),
        _hoisted_3
      ]),
      _createVNode("div", {
        class: "copyBtn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
      }, "复制")
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("ul", _hoisted_6, [
          _hoisted_7,
          _createVNode("li", null, [
            _hoisted_8,
            _createVNode("p", null, _toDisplayString(_ctx.state.oldReportCode), 1)
          ]),
          _createVNode("li", null, [
            _hoisted_9,
            _createVNode("p", null, _toDisplayString(_ctx.state.reportCode), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.diffGroupList, (group) => {
        return (_openBlock(), _createBlock("div", {
          class: "contentItem",
          key: group.checkType
        }, [
          _createVNode("div", _hoisted_10, [
            _createVNode("b", null, _toDisplayString(group.checkType), 1),
            (group.diffCount > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_11, [
                  _createVNode("b", null, _toDisplayString(group.diffCount), 1),
                  _hoisted_12
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_13, "无差异项"))
          ]),
          _withDirectives(_createVNode("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.diffItemList, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "itemRow",
                key: item.checkItemCode
              }, [
                _createVNode("h6", _hoisted_15, _toDisplayString(item.checkItemName), 1),
                _createVNode("p", {
                  class: ["itemcol", {"cred": _ctx.isRed(item, "old", group.checkType==="检测结论")}],
                  onClick: ($event: any) => (_ctx.viewPhoto(item, "old"))
                }, [
                  _createTextVNode(_toDisplayString(item.oldDefect) + " ", 1),
                  _withDirectives(_createVNode(_component_van_icon, {
                    class: "ml4",
                    name: "photo"
                  }, null, 512), [
                    [_vShow, item.oldPhotos.length>0]
                  ])
                ], 10, ["onClick"]),
                _createVNode("p", {
                  class: ["itemcol", {"cred": _ctx.isRed(item, "now", group.checkType==="检测结论")}],
                  onClick: ($event: any) => (_ctx.viewPhoto(item, "now"))
                }, [
                  _createTextVNode(_toDisplayString(item.nowDefect) + " ", 1),
                  _withDirectives(_createVNode(_component_van_icon, {
                    class: "ml4",
                    name: "photo"
                  }, null, 512), [
                    [_vShow, item.nowPhotos.length>0]
                  ])
                ], 10, ["onClick"])
              ]))
            }), 128))
          ], 512), [
            [_vShow, group.hasDiff]
          ])
        ]))
      }), 128))
    ]),
    _withDirectives(_createVNode("div", _hoisted_16, [
      _createVNode("p", _hoisted_17, [
        _createVNode(_component_van_icon, {
          name: "arrow-left",
          onClick: _ctx.closeSwiper
        }, null, 8, ["onClick"]),
        _createVNode("span", null, _toDisplayString(_ctx.state.checkItemName), 1),
        _hoisted_18
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "swiper-slide",
                key: index
              }, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("img", {
                      src: item.photoPath
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("p", null, [
                    _createVNode("span", null, _toDisplayString(item.defectDesc), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.state.currentSlideIndex) + " / " + _toDisplayString(_ctx.state.photoList.length), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.showSwiper]
    ])
  ], 2))
})